import styled from 'styled-components';

export const PointRedeemShippingContainerStyled = styled.div`
  padding-bottom: 20px;
`;
